<ng-container *ngFor="let fg of field.fieldGroup; let index = index; trackBy: trackByFieldId">
  <formly-field *ngIf="subsection === index" [field]="fg"></formly-field>
</ng-container>
